import React, { useState } from 'react';
import Icon from '../components/Icon';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import { setPolishValidationMessage, clearValidationMessage } from '../utils/validation';
import '../styles/Auth.css';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.email, formData.password);
    
    setLoading(false);

    if (result.success) {
      const from = location.state?.from;
      if (from) {
        navigate(from.pathname, { 
          replace: true,
          state: from.state 
        });
      } else {
        navigate(getDashboardRoute(result.user.role), { replace: true });
      }
    } else {
      setError(result.error);
    }
  };

  const getDashboardRoute = (role) => {
    switch (role) {
      case 'client':
        return '/dashboard/client';
      case 'salon':
        return '/dashboard/salon';
      case 'admin':
        return '/dashboard/admin';
      case 'franchisee':
        return '/dashboard/franchisee';
      default:
        return '/';
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-box">
          <div className="auth-header">
            <Logo size="small" dark={true} />
            <h1>Zaloguj się</h1>
            <p>Witaj z powrotem w HAIRKUS!</p>
          </div>

          {error && (
            <div className="error-message">
              <Icon name="warning" color="#f59e0b" style={{marginRight:'5px'}} /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="twoj@email.com"
                required
                onInvalid={setPolishValidationMessage}
                onInput={clearValidationMessage}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Hasło</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
                onInvalid={setPolishValidationMessage}
                onInput={clearValidationMessage}
              />
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Logowanie...' : 'Zaloguj się'}
            </button>
          </form>

          <div className="auth-footer">
            <p>Nie masz konta? <Link to="/register">Zarejestruj się</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
